<div class="header">
    @if (data.title) {
        <h4
            mat-dialog-title
        >{{data.title}}
        </h4>
    }
    <button
        class="close-button"
        mat-icon-button
        mat-dialog-close
    >
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <ng-container #contentHost></ng-container>
</div>
<div
    class="action-buttons"
    mat-dialog-actions
>
    <button mat-raised-button color="primary" mat-dialog-close>
        Zamknij
    </button>
</div>
